/* src/app/admin-dashboard/company-sites/detail-site/detail-site.component.css */
.example-icon {
  padding: 0 14px;
}
.example-spacer {
  flex: 1 1 auto;
}
.material-icons {
  cursor: pointer;
  padding-right: 10px;
}
.action {
  margin: 5px;
}
.system-name {
  font-size: 20px;
}
/*# sourceMappingURL=detail-site.component.css.map */
